import { useModalStore } from '@/shared/lib';
import { ApiTokensListModal } from '../ui';

function useApiTokensModal() {
  const { showDialogComponent, closeDialog } = useModalStore();

  const openApiTokensModal = (accountNumber?: string) => {
    showDialogComponent({
      component: <ApiTokensListModal accountNumber={accountNumber || ''} />,
      className: 'sm:max-w-[48rem] max-h-[90vh] overflow-y-auto border-0 flex',
      onClose: closeDialog,
    });
  };

  return { openApiTokensModal };
}

export { useApiTokensModal };
